import { colInitialsList } from "./initials";
import { createColumnProps } from "./_builder";

export type SummaryResource = {
  id: string;
  displayName: string;
  description?: string;
  pictureUrl?: string;
  url?: string;
};

export const colLecturer = createColumnProps(
  colInitialsList,{
    dataField: "lecturers"
  });
